import { ViewType } from '@hooks/export/Model';
import { PageType } from '@utils/pageConfig/Types';
import { elements } from '@ecosystem/newron-design-system';
import React from 'react';
import { ExploreTabView, ProductsTabView } from '@components/tab-nav/TabConfig';

const { Icon } = elements;
const { Table, LineChart, BarChartHoriz, BarChartVert, BubbleChart } = Icon.icons;
const IconMapping: Partial<Record<ViewType, React.ReactElement>> = {
  [ViewType.Table]: <Table />,
  [ViewType.LineChart]: <LineChart />,
  [ViewType.BarChart]: <BarChartHoriz />,
  [ViewType.StackedChart]: <BarChartVert />,
  [ViewType.BubbleChart]: <BubbleChart />,
};

const ToggleViewButtonConfig = {
  [PageType.CATEGORY_LEADERBOARD]: {
    options: [ViewType.Table, ViewType.BarChart],
    defaultView: ViewType.Table,
  },
  [PageType.OPPORTUNITY_REVIEW]: {
    options: [ViewType.Table, ViewType.BubbleChart],
    defaultView: ViewType.Table,
  },
  [PageType.PERFORMANCE_ANALYSIS]: {
    options: [ViewType.Table, ViewType.LineChart, ViewType.BarChart, ViewType.StackedChart],
    defaultView: ViewType.Table,
  },
  [PageType.RI_PRODUCT]: {
    [ProductsTabView.Leaderboard]: {
      options: [ViewType.Table, ViewType.BarChart],
      defaultView: ViewType.Table,
    },
  },
  [PageType.EXPLORE]: {
    [ExploreTabView.Leaderboard]: {
      options: [ViewType.Table, ViewType.BarChart],
      defaultView: ViewType.Table,
    },
    [ExploreTabView.Trends]: {
      options: [ViewType.StackedChart, ViewType.LineChart],
      defaultView: ViewType.StackedChart,
    },
  },
};

const getToggleViewConfig = (pageType: PageType, pathname: string) => {
  const tabName = pathname.substring(pathname.lastIndexOf('/') + 1);
  const isNestedPage = [PageType.RI_PRODUCT, PageType.EXPLORE].includes(pageType);
  const defaultView = { options: [ViewType.Table], defaultView: ViewType.Table };

  if (isNestedPage && tabName) {
    const nestedConfig = ToggleViewButtonConfig[pageType]?.[tabName as ExploreTabView | ProductsTabView];
    return nestedConfig ?? defaultView;
  }

  const config = ToggleViewButtonConfig[pageType];
  return config ?? defaultView;
};

export { IconMapping, getToggleViewConfig };
